import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../Loading';

const Content = React.lazy(() => import('./Content'));

const StyledModal = styled(Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ModalContent = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  maxHeight: '90vh',
  position: 'relative',
  background: theme.palette.background.gradient,
  backgroundImage: `url(/assets/img/organized${theme.palette.mode === 'dark' ? '-dark' : '-light'}.jpg)`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[10],
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: '90%',
  outline: 'none',
  [theme.breakpoints.up('sm')]: {
    '.formContainer': {
      marginLeft: '20%',
    },
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '80vw',
    '.formContainer': {
      marginLeft: '36%',
    },
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '64vw',
    backgroundPosition: 'center',
    '.formContainer': {
      marginLeft: '54%',
    },
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: '50vw',
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  color: theme.palette.contrastText,
}));

const CallbackModal = ({ open, onClose }) => {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
    >
      <ModalContent
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="callback-modal-title"
        aria-describedby="callback-modal-description"
      >
        <Tooltip title="Fenster schließen">
          <CloseButton onClick={onClose} aria-label="schließen">
            <CloseIcon />
          </CloseButton>
        </Tooltip>
        <React.Suspense fallback={<Loading />}>
          <Content onClose={onClose} />
        </React.Suspense>
      </ModalContent>
    </StyledModal>
  );
};

CallbackModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CallbackModal;
